var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.66667C10.3536 4.66667 10.6928 4.80715 10.9428 5.0572C11.1929 5.30724 11.3333 5.64638 11.3333 6M14 6C14.0002 6.62478 13.854 7.24092 13.5732 7.79904C13.2924 8.35715 12.8847 8.84172 12.3829 9.21392C11.8811 9.58612 11.2991 9.83559 10.6835 9.94235C10.0679 10.0491 9.43584 10.0102 8.838 9.82867L7.33333 11.3333H6V12.6667H4.66667V14H2.66667C2.48986 14 2.32029 13.9298 2.19526 13.8047C2.07024 13.6797 2 13.5101 2 13.3333V11.6093C2.00004 11.4325 2.0703 11.263 2.19533 11.138L6.17133 7.162C6.00497 6.61201 5.95904 6.03263 6.0367 5.4633C6.11435 4.89397 6.31375 4.34805 6.62133 3.8627C6.92891 3.37735 7.33744 2.96397 7.81913 2.65068C8.30082 2.3374 8.84434 2.13157 9.41272 2.04721C9.9811 1.96284 10.561 2.00193 11.1129 2.16179C11.6648 2.32166 12.1758 2.59856 12.6111 2.97365C13.0464 3.34873 13.3958 3.8132 13.6354 4.33543C13.8751 4.85766 13.9994 5.4254 14 6Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyOutline);
export default __webpack_public_path__ + "static/media/KeyOutline.e37ab31c537c2881b43ec35680f5d92a.svg";
export { ForwardRef as ReactComponent };